import { useDraggable } from '@dnd-kit/core';
import React, { FC } from 'react';
import { MaterialIcon } from '../../../../components';
import { classNames } from '../../../../utils';
import { DragData } from '../models';

import './ToolboxItem.scss';

interface Props {
  readonly id: string;
  readonly icon: string;
  readonly name: string;
  readonly nodeType: string;
  readonly nextId: number;
  readonly description?: React.JSX.Element | string;
  readonly isDragOverlay?: boolean;
}

export const ToolboxItem: FC<Props> = ({
  id,
  icon,
  name,
  nodeType,
  description,
  isDragOverlay,
  nextId,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    data: {
      type: nodeType,
      source: 'toolbox',
    } as DragData,
    id: `toolbox-item-${id}-${nextId}`,
  });

  return (
    <div
      className={classNames(
        {
          dragging: isDragOverlay,
          'is-dragging': isDragging,
        },
        'editor-toolbox-item',
      )}
      id={`toolbox-item-${id}`}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
    >
      <div className="handlebar">
        <MaterialIcon name="drag_indicator" />
      </div>
      <div className="icon">
        <MaterialIcon name={icon} />
      </div>
      <div className="content">
        <strong>{name}</strong>
        {description && <div className="description">{description}</div>}
      </div>
    </div>
  );
};
